import React from "react"
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCOBackButton from "../../fundamentals/CCOBackButton";


export interface Props {
    backUri: string
}

function P011PublicationBackButton(props: Props) {
    return <CCOComponentWrapper noTopMargin smallmargin>
        <CCOContainer>
            <CCOBackButton buttonLabelKey='cart.back_to_overview' backUri={props.backUri}
                           customStyle={{
                               padding: 'unset',
                               '&:hover': {backgroundColor: 'transparent'}
                           }}/>
        </CCOContainer>
    </CCOComponentWrapper>
}

export default P011PublicationBackButton